class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.handles = [];
    this.domain = `${Shopify.routes.root}`;
    this.querySelectorAll(".product-swatch").forEach((swatch) => {
      this.handles.push(swatch.getAttribute("data-handle"));
    });
    this.getAllProducts(this.handles);
  }

  updateProductCard(newHandle) {
    const product = this.getProductData(newHandle);
    if(!product) return;
    if (
      this.querySelector(".product-swatch").hasAttribute("data-url") &&
      this.querySelector(".product-swatch").getAttribute("data-url")
    ) {
    } else {
      this.querySelector(
        ".product-url"
      ).href = `${this.domain}products/${product.handle}`;
      if (this.querySelector(".item-url")) {
        this.querySelector(
          ".item-url"
        ).href = `${this.domain}products/${product.handle}`;
      }
      if (this.querySelector(".card-information__wrapper > a")) {
        this.querySelector(
          ".card-information__wrapper > a"
        ).href = `${this.domain}products/${product.handle}`;
      }
      this.updateProductCardPrice(product);
    }
    this.updateProductCardImg(
      product.featured_image,
      product.media[1]
        ? product.media[1].src
        : product.media[0]
        ? product.media[0].src
        : ""
    );
    this.updateProductCardColor(product);

    //   this.updateProductSaleBadge(product);
    //   this.updateProductStockBadge(product.handle);
  }

  updateProductSaleBadge(product) {
    if (product.compare_at_price) {
      if (this.querySelector(".items-badges"))
        this.querySelector(".items-badges").innerHTML =
          '<span class="badge badge--bottom-left color-accent-2" aria-hidden="true">Sale</span>';
        var saleBadge = document.createElement('span');
        saleBadge.className = 'badge-item badge-sale';
        saleBadge.textContent = 'Sale';
        this.querySelector(".items-badges").appendChild(newSpan);
    } else {
      var saleSpan = document.querySelector('.badge-sale');
      saleSpan ? saleSpan.remove() : '';
    }
  }

  updateProductStockBadge(product_handle) {
    fetch(`${this.domain}products/${product_handle}?view=inventory`)
      .then((response) => response.json())
      .then((data) => {
        const product_badge = this.querySelector(".product_badge");
        if (product_badge.hasAttribute("data-badge")) {
          product_badge.innerHTML = product_badge.getAttribute("data-badge");
          product_badge.style.display = "block";
        } else if (data.badge) {
          product_badge.innerHTML = "Low Stock";
          product_badge.style.display = "block";
        } else {
          product_badge.innerHTML = "";
          product_badge.style.display = "none";
        }
      });
  }

  updateProductCardImg(featuredSrc, secondarySrc) {
    const featuredImg = this.querySelector(".featured-image");
    const hoverImg = this.querySelector(".secondary-image");

    function getSrcWithSize(imageSrc) {
      const imageReg = /(.jpg|.png|.jpeg)/g;
      const insertIndex = imageSrc.search(imageReg);
      const srcSize =
        imageSrc.slice(0, insertIndex) +
        `_${featuredImg.width + 100}x${featuredImg.height + 100}` +
        imageSrc.slice(insertIndex);

      return srcSize;
    }

    if (featuredImg) featuredImg.srcset = getSrcWithSize(featuredSrc);
    if (hoverImg) hoverImg.srcset = getSrcWithSize(secondarySrc);
  }

  updateProductCardColor(product) {
    const color = product.options.find(
      (option) => option.name == "Color" || option.name == "Couleur"
    );
    this.querySelectorAll(".product-color").forEach((colorElement) => {
      colorElement.textContent = color.values[0].split("+").join(", ");
    });
  }

  updateProductCardPrice(product) {
    if(product.compare_at_price || product.title.toLowerCase().includes('pack')) {
      if(this.querySelector(".price-item.price-item--sale")) this.querySelector(".price-item.price-item--sale").textContent = `${window.theme.cart_currency_symbol}` + (product.price / 100) + ' ';
      this.querySelector(".price .price__regular").style.display = "none";
      this.querySelector(".price .price__sale").style.display = "flex";
    } else {
      console.log('Hereeeeeeeeeeeeeeeee');
      if(this.querySelector(".price-item--regular")) this.querySelector(".price-item--regular").textContent = `${window.theme.cart_currency_symbol}` + (product.price / 100) + ' ';
      this.querySelector(".price .price__sale").style.display = "none";
      this.querySelector(".price .price__regular").style.display = "flex";
    }
  }

  getProductData(handle) {
    const scriptID = this.getAttribute("data-json-script-id");
    const data = JSON.parse(document.getElementById(scriptID).textContent);
    const product = data.find(
      (product) => product !== null && product.handle === handle
    );

    return product;
  }

  static get observedAttributes() {
    return ["data-selected-swatch"];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue === null) return;
    this.updateProductCard(newValue);
  }

  storeRelatedProductsJSON(data) {
    const scriptID = this.getAttribute("data-json-script-id");
    const script = this.querySelector(`#${scriptID}`);
    script.textContent = JSON.stringify(data);
  }

  getAllProducts(handles) {
    const productPromises = [];

    for (let handle of handles) {
      productPromises.push(
        fetch(`${this.domain}products/${handle}.js`)
          .then((response) => response.json())
          .then((data) => data)
          .catch((err) => {
            console.log(err);
          })
      );
    }

    Promise.allSettled(productPromises).then((results) => {
      const products = [];
      results.forEach((result) => {
        if (result.status === "fulfilled") products.push(result.value);
      });
      this.storeRelatedProductsJSON(products);
    });
  }
}

customElements.define("product-card", ProductCard);

class ProductSwatch extends HTMLElement {
  constructor() {
    super();
    this.swatches = this.querySelectorAll(".product-swatch");
    this.domain = `${Shopify.routes.root}`;
    this.swatches.forEach((swatch) => {
      swatch.addEventListener("click", this.handleSwatchChange.bind(this));
    });
  }

  connectedCallback() {
    let swatch =
      this.querySelectorAll(".product-swatch")[0].querySelector(
        ".swatch-color"
      );
    this.handleSwatchChange();
  }

  updateSelectedSwatchClass(targetSwatch) {
    this.swatches.forEach((swatch) => {
      swatch.classList.remove("swatch-selected");
    });

    targetSwatch.classList.add("swatch-selected");
  }

  get selectedProductHandle() {
    return this.closest("product-card")
      .querySelector("quick-add") 
      .getAttribute("data-selected-swatch");
  }

  updateAttributes(handle) {
    const productCard = this.closest("product-card");
    const quickAdd = productCard.querySelector(".quick-add-data");
    const mobileQuickAdd = productCard.querySelector("mobile-quick-add");
    productCard.setAttribute("data-selected-swatch", handle);
    quickAdd.setAttribute("data-selected-swatch", handle);
    mobileQuickAdd.setAttribute("data-selected-swatch", handle);

    if (quickAdd.querySelectorAll(".quick-add-option").length == 1) {
      productCard
        .querySelectorAll(".quick-add-option-value")
        .forEach((option) => {
          const handle = this.selectedProductHandle;
          const products = JSON.parse(
            option.closest("product-card").querySelector("script").textContent
          );
          const selectedProduct = products.find(
            (data) => data.handle === handle
          );

          const product = selectedProduct;
          const position = option.parentElement.getAttribute(
            "data-option-position"
          );
          const value = option.textContent;
          const filterOptionPosition = position;

          const availableOptions = product.variants
            .filter(
              (variant) => variant[position] == value && variant.available
            )
            .map((variant) => variant[filterOptionPosition]);

          availableOptions.includes(option.textContent)
            ? option.classList.remove("unavailable")
            : option.classList.add("unavailable");
        });
    }
  }

  handleSwatchChange(e) {
    let swatch = "";
    if (!e) {
      swatch = this.querySelector(".product-swatch");
    } else {
      swatch = e.target.closest(".product-swatch");
    }
    const handle = swatch.getAttribute("data-handle");
    let newURL = swatch.getAttribute("data-url");
    if (newURL) {
      let links = this.parentNode.parentNode.parentNode.querySelectorAll("a");
      var domain = this.domain;
      if (domain.endsWith("/")) {
        domain = domain.slice(0, -1);
      }
      newURL = domain + newURL;
      links.forEach((l) => {
        l.href = newURL;
      });
    }
    if (swatch.classList.contains("swatch-selected")) return;

    this.updateSelectedSwatchClass(swatch);
    this.updateAttributes(handle);
  }
}

customElements.define("product-swatch", ProductSwatch);

class QuickAdd extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll(".quick-add-option-value").forEach((option) => {
      option.addEventListener("click", this.handleOptionChange.bind(this));
    });
    this.optionsToSelect = this.querySelectorAll(".quick-add-option").length;
    this.selectedOptions = 0;

    window.addEventListener("load", () => {
      this.querySelectorAll(
        '.ds-stretch-fit.skinny .quick-add-option-values[data-option-name="Inseam"] span'
      ).forEach((option) => {
        if (option.innerHTML == 32) {
          option.click();
        }
      });
      setTimeout(() => {
        if (this.optionsToSelect == 1) {
          this.querySelectorAll(".quick-add-option-value").forEach((option) => {
            const handle = this.selectedProductHandle;
            const products = JSON.parse(
              option.closest("product-card").querySelector("script").textContent
            );
            const selectedProduct = products.find(
              (data) => data.handle === handle
            );

            const product = selectedProduct;
            const position = option.parentElement.getAttribute(
              "data-option-position"
            );
            const value = option.textContent;
            const filterOptionPosition = position;

            const availableOptions = product.variants
              .filter(
                (variant) => variant[position] == value && variant.available
              )
              .map((variant) => variant[filterOptionPosition]);

            availableOptions.includes(option.textContent)
              ? option.classList.remove("unavailable")
              : option.classList.add("unavailable");
          });
        }
      }, 1000);
    });
  }

  static get observedAttributes() {
    return ["data-selected-swatch"];
  }

  get selectedProductHandle() {
    return this.getAttribute("data-selected-swatch");
  }

  renderNewOptions() {
    const selectedProduct = this.getSelectedProduct();
    this.selectedOptions = 0;
    console.lo;
    selectedProduct.options.forEach((option) => {
      if (option.name !== "Color" && option.name !== "Couleur") {
        const optionsContainer = this.querySelector(
          `[data-option-name="${option.name}"]`
        );
        const newOptions = [];
        console.log(`${option.name}`);
        option.values.forEach((value) => {
          const option = document.createElement("span");
          option.classList.add("quick-add-option-value");
          option.textContent = value;
          option.addEventListener("click", this.handleOptionChange.bind(this));
          newOptions.push(option);
        });
        optionsContainer.replaceChildren(...newOptions);
      }
    });
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue === null) return;
    this.renderNewOptions();
  }

  getSelectedProduct() {
    const handle = this.selectedProductHandle;
    console.log(handle);
    const products = JSON.parse(
      this.closest("product-card").querySelector("script").textContent
    );
    const selectedProduct = products.find(
      (data) => data !== null && data.handle === handle
    );
    return selectedProduct;
  }

  showAvailableOptions(option) {
    const product = this.getSelectedProduct(option);
    console.log(product);
    const position = option.parentElement.getAttribute("data-option-position");
    const value = option.textContent;
    const filterOptionPosition = position === "option2" ? "option3" : "option2";

    const availableOptions = product.variants
      .filter((variant) => variant[position] == value && variant.available)
      .map((variant) => variant[filterOptionPosition]);

    if (!option.classList.contains("selected")) {
      return this.querySelectorAll(
        `[data-option-position="${filterOptionPosition}"] .quick-add-option-value`
      ).forEach((option) => {
        option.classList.remove("unavailable");
      });
    }

    this.querySelectorAll(
      `[data-option-position="${filterOptionPosition}"] .quick-add-option-value`
    ).forEach((option) => {
      availableOptions.includes(option.textContent)
        ? option.classList.remove("unavailable")
        : option.classList.add("unavailable");
    });
  }

  getSelectedProductID() {
    const options = [];
    this.querySelectorAll(".selected").forEach((option) => {
      options.push(option.textContent);
    });

    const optionsTitle = options.join(" / ");
    const product = this.getSelectedProduct();

    const selectedVariant = product.variants.find((variant) =>
      variant.title.includes(` ${optionsTitle}`)
    );

    return selectedVariant.id;
  }

  getProductFinalSaleBage() {
    const product = this.getSelectedProduct();
    let finalSale = false;
    if (
      product.tags.includes("mens-final-sale") ||
      product.tags.includes("womens-final-sale")
    )
      finalSale = true;
    return finalSale;
  }

  addProductToCart() {
    const id = this.getSelectedProductID();
    const finalSale = this.getProductFinalSaleBage();
    const finalSaleProps = finalSale
      ? { _final_sale: "yes" }
      : { _final_sale: "no" };
    const sideCart = document.querySelector("side-cart");

    new Promise((resolve, reject) => {
      resolve(sideCart.addToCart(id, 1, finalSaleProps));
    }).then(() => {
      document.querySelector(".loader").classList.remove("show");
      sideCart.openCart();
      this.renderNewOptions();
    });
  }

  handleOptionChange(e) {
    const option = e.target;
    const prevSelectedOption = option.parentElement.querySelector(".selected");
    if (prevSelectedOption) {
      prevSelectedOption.classList.remove("selected");
      --this.selectedOptions;
    }

    if (!option.isEqualNode(prevSelectedOption)) {
      option.classList.add("selected");
      ++this.selectedOptions;
    }

    this.showAvailableOptions(option);

    if (this.selectedOptions === this.optionsToSelect) {
      if (this.constructor.name === "MobileQuickAdd") {
        this.querySelector(
          ".mobile-quick-add-options__wrapper"
        ).classList.remove("open");
        this.querySelector(".mobile-quick-add-btn").classList.remove("open");
      }
      document.querySelector(".loader").classList.add("show");
      return this.addProductToCart();
    }
  }
}

customElements.define("quick-add", QuickAdd);

class MobileQuickAdd extends QuickAdd {
  constructor() {
    super();
    this.querySelector(".mobile-quick-add-btn").addEventListener(
      "click",
      this.showMobileOptions.bind(this)
    );
  }

  showMobileOptions(e) {
    document
      .querySelectorAll("mobile-quick-add .mobile-quick-add-options__wrapper")
      .forEach((el) => {
        if (el != e.target.previousElementSibling) el.classList.remove("open");
      });
    document
      .querySelectorAll("mobile-quick-add .mobile-quick-add-btn")
      .forEach((el) => {
        if (el != e.target) el.classList.remove("open");
      });
    const mobileOptions = e.target.previousElementSibling;
    e.target.classList.toggle("open");
    mobileOptions.classList.toggle("open");
  }
}

customElements.define("mobile-quick-add", MobileQuickAdd);
